import DocumentDetailsRow, {
	IDocumentDetailsItem
} from '../../../../common/components/documentViewer/documentDetailsRow';
import RupTooltip from '../../../../common/components/rupTooltip';
import { caption } from '../../../../common/styles/commonStyles';
import { toKebabCase } from '../../../../common/utils/stringUtils';
import { OrderViewerOptions } from '../../typing/enums';
import { IOrderDetailsViewModel } from '../../typing/orderViewerViewModel';
import { IOrderViewerMainStore } from '../../typing/stores';
import OrderPrice from './orderPrice';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors } from 'copyright-clearance-center-common-ui';
import { inject, observer } from 'mobx-react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			gap: '0.25rem'
		},
		text: {
			...caption
		},
		termsToolTipLink: {
			...caption,
			wordBreak: 'break-word',
			display: 'inline',
			marginRight: '0.25rem',
			color: Colors.primary500
		}
	})
);

export interface IOrderDetailsTabProps {
	orderDetails?: IOrderDetailsViewModel;
	viewerOptions?: OrderViewerOptions;
}

const OrderDetailsTab: React.FunctionComponent<IOrderDetailsTabProps> = props => {
	const classes = useStyles();

	let rowKey = 0;
	const createRow = (title?: string, value?: string | React.ReactNode, useHtml = false, valueClass?: string) => {
		if (value) {
			const item: IDocumentDetailsItem = {
				title: title,
				value: value,
				testId: toKebabCase(title)
			};
			return <DocumentDetailsRow key={rowKey++} items={item} valueClass={valueClass} useHtml={useHtml} />;
		}

		return <></>;
	};

	const showReceipt = (props.viewerOptions & OrderViewerOptions.ShowReceipt) === OrderViewerOptions.ShowReceipt;

	return (
		<div className={classes.root}>
			{createRow(localize('Usage'), props.orderDetails.usage)}
			{props.orderDetails.copyrightTermsDisplayRequired
				? createRow(localize('Copyright terms'), props.orderDetails.terms, true)
				: props.orderDetails.terms && (
						<div className={classes.text}>
							{createRow(
								localize('Copyright terms'),
								<RupTooltip
									title={
										<div
											style={{ overflow: 'auto', maxHeight: '18.75rem' }}
											dangerouslySetInnerHTML={{ __html: props.orderDetails.terms }}
										/>
									}
									arrow
								>
									<span>{localize('Terms apply')}</span>
								</RupTooltip>,
								false,
								clsx('rup-link', classes.termsToolTipLink)
							)}
						</div>
				  )}
			{createRow(localize('Fulfillment terms'), props.orderDetails.fulfillmentTerms, true)}
			{showReceipt && <OrderPrice />}
		</div>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	orderDetails: stores.orderViewerStore.viewModel.orderDetails,
	viewerOptions: stores.orderViewerStore.viewModel.viewerOptions
}))(observer(OrderDetailsTab));
